import { useMutation } from '@tanstack/react-query';
import apiClient from '../services/apiService';

export const useDeleteProperty = () => {
  return useMutation({
    mutationFn: (propertyId) => apiClient.delete(`/api/properties/${propertyId}`),
  });
};
